/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Network_Configuration_Dialog_StepsInputs */



/**
* | output |
* | --- |
* | "Network {current} of {total}" |
*
* @param {Network_Configuration_Dialog_StepsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_configuration_dialog_steps = /** @type {((inputs: Network_Configuration_Dialog_StepsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Configuration_Dialog_StepsInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Network ${i?.current} of ${i?.total}`)
	return /** @type {LocalizedString} */ (`Réseau ${i?.current} sur ${i?.total}`)
});